import React from "react";

import { IActiveLearningIssue } from "../../../../../state";
import Issue1 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson6/Material/Issue1";
import Issue2 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson6/Material/Issue2";
import Issue3 from "../../../../../organisms/teacher/ActiveLearningLessons/Lesson6/Material/Issue3";
import styles from "../../ActiveLearningLesson.module.scss";
import SaveAnswerButton from "../../../../../atoms/ActiveLearning/SaveAnswerButton";

type Lesson6MaterialProps = {
  findIssue?: (no: number) => IActiveLearningIssue | undefined;
};

export const Lesson6Material = (props: Lesson6MaterialProps) => {
  return (
    <>
      <div className={styles.section}>
        <Issue1 issue={props.findIssue && props.findIssue(1)} />
      </div>
      <div className={styles.saveAnswer}>
        <SaveAnswerButton />
      </div>
      <div className={styles.section}>
        <Issue2 issue={props.findIssue && props.findIssue(2)} />
      </div>
      <div className={styles.section}>
        <Issue3 issue={props.findIssue && props.findIssue(3)} />
      </div>
      <div className={styles.saveAnswer}>
        <SaveAnswerButton />
      </div>
    </>
  );
};
export default Lesson6Material;
